import './total-line.css'

/**
 * What a figure is, and what it comes to.
 *
 * One component for both halves of a total, because they are one statement:
 * `emphasis="total"` is the sum and everything above it is what makes it up.
 * Two components would let a breakdown and the line it adds to be set in two
 * different faces, which is the surest way to make a reader check the
 * arithmetic instead of reading the answer.
 *
 * The figure takes the numeric face, the way every figure in this system does.
 */
export function TotalLine({
  label,
  amount,
  note,
  emphasis = 'line',
}: {
  label: string
  /** Formatted where it is read — a total is money, and money has one spelling. */
  amount: string
  /** What the line is, where the label cannot carry it. */
  note?: string
  emphasis?: 'line' | 'total'
}) {
  return (
    <div className="total-line" data-emphasis={emphasis}>
      <span className="total-line__text">
        <span className="total-line__label">{label}</span>
        {note ? <span className="total-line__note">{note}</span> : null}
      </span>
      <span className="total-line__amount tabular">{amount}</span>
    </div>
  )
}
